import { ActivityCenterContextType } from "../../Context/ActivityCenter";
import { getDataReader } from "../../livedataFuncs";
import { ProvincesShortCode } from "../navigationTypes";
import VerifyLawyer from "./VerifyLawyer";

export type TaskResult = {
    task_name: "Lawyer Verification";
    task_search: string; // ex: lawyer name
    task_msgs: TaskMsg[];
    task_link?: string;
}

export type TaskMsg = {
    text: string;
    flag: "Yellow" | "Red"
    RWValue: string;
    SearchValue: string;
}

export type FileLock = {
    status: boolean,
    sessionID: string,
    stationID: string,
    currentUser: string,
};
namespace BGTask {
    function BGTaskLog(
        province: ProvincesShortCode,
        firmId: number,
        AppID: string,
        sid: string,
        result: TaskResult
    ) {
        if (result.task_msgs.length > 0) {
            fetch(`/${process.env.REACT_APP_RWAPI_ENDPOINT}/api/${province}/${firmId}/set/bgtask?SessionID=${sid}`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify({
                        appId: AppID,
                        TaskResult: result
                    })
                })
        }
    }

    export async function CheckFileLockStatus(
        province: ProvincesShortCode,
        firmId: number,
        AppID: string,
        sid: string,
        callback: (d: FileLock) => void
    ): Promise<void> {
        try {
            const response = await fetch(`/${process.env.REACT_APP_RWAPI_ENDPOINT}/api/${province}/${firmId}/fileLockStatus?SessionID=${sid}&AppID=${AppID}`);
            if (response.status === 200) {
                const payload = await response.json()
                callback({
                    status: payload.result.isLock,
                    sessionID: payload.result.sessionID,
                    stationID: payload.result.stationID,
                    currentUser: payload.result.curUser
                });
                return;
            }
        }
        catch (e) {
            console.log(e)
        }
    }

    export async function FreeSession(
        province: ProvincesShortCode,
        firmId: number,
        AppID: string,
        oldSid: string,
        sid: string
    ): Promise<boolean> {
        try {
            const response = await fetch(`/${process.env.REACT_APP_RWAPI_ENDPOINT}/api/${province}/${firmId}/freeSession?SessionID=${sid}&AppID=${AppID}&currentSession=${oldSid}`);
            if (response.status === 200) {
                return true;
            }
        } catch (e) {  }
        return false;
    }

    export function CheckWholeFile(
        province: ProvincesShortCode,
        firmId: number,
        AppID: string,
        sid: string,
        dataroot,
        lddActivityCenterAdd: ActivityCenterContextType["Add"]
    ): void {
        // return;
        
        // Skip lawyer verification for mortgage files
        const DataReaderObj = getDataReader(dataroot);
        if (DataReaderObj?.getPSM() === 'M') {
            return;
        }
        
        VerifyLawyer.SearchLawSociety(province, firmId, AppID, sid, dataroot)
        .then(result => {
            const fileNumber = DataReaderObj?.getFileNumber?.() || "Unknown File";
            const lawyerName = result.task_search || "the lawyer";

            let lawyerInfo = `We couldn't verify some information for ${lawyerName} on file ${fileNumber}: `;
            result.task_msgs.forEach((msg, index) => {
                lawyerInfo += msg.text;
                if (result.task_msgs.length - 1 !== index && !(result.task_msgs.length - 2 === index)) {
                    lawyerInfo += ', ';
                } else if (result.task_msgs.length - 2 === index) {
                    lawyerInfo += ' and ';
                }
            });
            lawyerInfo += '.'
            if (result.task_msgs.length >= 1) {
                lddActivityCenterAdd(
                    lawyerInfo,
                    { useMyCloud: false, useMyDrive: false, url: result.task_link },
                    'error',
                    undefined,
                    true
                );
                // log it in storage if any msg
                BGTaskLog(province, firmId, AppID, sid, result);
            }
        })
        .catch(e => {
            console.log(e)
        });
    }
}

export default BGTask;